<template>
    <div class="about-rad">
        <h3>Развойна дейност</h3>
        <p class="indent">Като голям производител на валцови и пресови полуфабрикати от алуминий и алуминиеви сплави, дружеството развива активна развойна дейност. Екипът от експерти от Дирекция „Иновации и развойна дейност“, заедно с експертите от Диркеция „Продажби“, продължават да проучват потенциалните пазарни ниши и разработват нови продукти. Основните развойни дейности през 2020 год. бяха насочени към разработването на нови изделия за автомобилната промишленост, както и нови сплави и продукти за валцовата част. Бяха анализирани и подобрени различни процеси. Дейностите са концентрирани основно върху внедряването на нови сплави, които досега не са били в продуктовото портфолио на компанията. Новите твърди и устойчиви на корозия сплави се тестват с успех. „Алкомет“ АД се стреми да увеличи броя на тези продукти с висока добавена стойност чрез технологично инженерство. </p>
        <p class="indent">В резултат на развойната дейност се раждат иновациите, които са в основата на развитието на конкурентоспособност и подобряване на качеството на живот.</p>
      <p class="indent" style="text-align:center;">
        <img style="width:400px !important;" v-scroll-reveal.reset="{ delay: 250 }" src="/static/img/about/au/0309_people.jpg" alt="">
      </p>

        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};</script>

<style scoped>
.about-rad h3 {
    margin: 40px auto;
    width: 60%;
    text-align: center;
}
.about-rad p {
    font-size: 19px;
    line-height: 32px;
    margin: 15px auto;
    text-align: justify;
    width: 60%;
}
</style>



// WEBPACK FOOTER //
// src/components/about/RAndD.vue